import * as React from "react";
const SvgFiRrAxeBattle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-axe-battle_svg__a)">
      <path
        fill="#062147"
        d="M21.56 2.141a2.6 2.6 0 0 0-1.767-1.1 2.74 2.74 0 0 0-2.093.558C16.001 2.935 14.483 3.68 13 3.912V3a1 1 0 0 0-2 0v.922C8.869 3.606 7.015 2.376 6.026 1.6a2.74 2.74 0 0 0-2.093-.559c-.724.11-1.351.5-1.767 1.101C.569 4.452 0 7.718 0 10.004c0 2.658.988 5.831 2.46 7.895a2.6 2.6 0 0 0 1.746 1.07 2.73 2.73 0 0 0 2.063-.535c1.262-.962 2.892-2.037 4.73-2.342V23a1 1 0 0 0 2 0v-6.915c1.951.3 3.76 1.4 5.006 2.35a2.76 2.76 0 0 0 2.063.533 2.6 2.6 0 0 0 1.747-1.07C23.427 15.634 24 12.23 24 10.002c0-2.592-.98-5.75-2.44-7.862M5.057 16.844a.75.75 0 0 1-.553.148.61.61 0 0 1-.416-.254C2.859 15.014 2 12.245 2 10.005c0-2.494.711-5.134 1.812-6.726a.61.61 0 0 1 .42-.26.74.74 0 0 1 .558.153c1.198.942 3.497 2.445 6.21 2.761v8.133c-2.402.3-4.414 1.612-5.943 2.778m15.13-.107a.61.61 0 0 1-.417.255.74.74 0 0 1-.552-.148c-1.503-1.146-3.733-2.48-6.218-2.779v-8.13c2.529-.304 4.569-1.688 5.936-2.764a.74.74 0 0 1 .559-.154.61.61 0 0 1 .419.261c1.228 1.776 2.085 4.542 2.085 6.726 0 2.085-.561 4.976-1.813 6.732z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-axe-battle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAxeBattle;
